import { createBrandTheme } from '../../createBrandTheme';
import mainfreightLogo from './mainfreight_logo.png';
import { BrandConfig } from '../../brandConfig';

const mainfreightTheme = createBrandTheme({
	palette: {
		primary: { main: '#1477C6' },
		secondary: { main: '#83C9FF' },
	},
	typography: {
		fontFamily: 'Roboto, sans-serif',
	},
	app: {
		navigation: {
			selectedBackground: '#E3F2FD',
			selectedText: '#0D47A1',
		},
	},
});

export const mainfreightBrandConfig: BrandConfig = {
	theme: mainfreightTheme,
	logo: mainfreightLogo,
};
